import {createSelector} from "reselect";

const breadcrumbSelector = state => state.contextState.breadcrumbs;
const contextSelector = state => state.contextState.context;

export const selectParentContext = createSelector(
	[contextSelector],
	(context) => {
		return {
			sampleEvent: context['sampleEvent'] != null ? null : null,
			conservationAction: context['sampleEvent'] != null ? context['conservationAction'] : null,
			project: context['conservationAction'] != null ? context['project'] : null,
			childProgram: context['project'] != null ? context['childProgram'] : null,
			parentProgram: context['childProgram'] != null ? context['parentProgram'] : null,
			organization: context['parentProgram'] != null ? context['organization'] : null,
			contextNodeId: null,
		}
	}
);

export const selectDeepestBreadcrumb = createSelector(
	[breadcrumbSelector],
	(breadcrumbs) => breadcrumbs?.slice?.(-1)?.[0] ?? {}
)
